import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["width", "height", "viewBox"]
const _hoisted_2 = ["r", "cx", "cy", "stroke", "stroke-width", "stroke-dasharray"]
const _hoisted_3 = ["r", "cx", "cy", "stroke", "stroke-width", "stroke-dashoffset", "stroke-dasharray"]
const _hoisted_4 = ["x", "y", "fill", "font-size"]

import { computed } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'ProgressRing',
  props: {
    value: {},
    size: { default: 200 },
    color: { default: '#76e5b1' },
    bgColor: { default: '#FFFFFF33' },
    label: {},
    width: { default: 16 },
    labelSize: { default: 52 },
    labelColor: { default: '#76e5b1' }
  },
  setup(__props: any) {

const props = __props

const radius = computed(() => (props.size / 2) - 10)
const circumfence = computed(() => (3.14 * radius.value * 2))
const viewBox = computed(() => `-${props.size * 0.125} -${props.size * 0.125} ${props.size * 1.25} ${props.size * 1.25}`)
const circleR = computed(() => (props.size / 2) - 10)
const cxy = computed(() => props.size / 2)
const textX = computed(() => (Math.round(cxy.value - (props.labelSize / 1.75))) + 'px')
const textY = computed(() => (Math.round(cxy.value - (props.labelSize / 3.25))) + 'px')

const offset = computed(() => ((1 - props.value) * circumfence.value).toString() + 'px')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: _ctx.size,
    height: _ctx.size,
    viewBox: viewBox.value,
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    style: {"transform":"rotate(-90deg)"}
  }, [
    _createElementVNode("circle", {
      r: circleR.value,
      cx: cxy.value,
      cy: cxy.value,
      fill: "transparent",
      stroke: _ctx.bgColor,
      "stroke-width": `${_ctx.width}px`,
      "stroke-dasharray": `${circumfence.value}px`,
      "stroke-dashoffset": "0"
    }, null, 8, _hoisted_2),
    _createElementVNode("circle", {
      r: circleR.value,
      cx: cxy.value,
      cy: cxy.value,
      stroke: _ctx.color,
      "stroke-width": `${_ctx.width}px`,
      "stroke-linecap": "round",
      "stroke-dashoffset": offset.value,
      fill: "transparent",
      "stroke-dasharray": `${circumfence.value}px`
    }, null, 8, _hoisted_3),
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("text", {
          key: 0,
          x: textX.value,
          y: textY.value,
          fill: _ctx.labelColor,
          "font-size": _ctx.labelSize+'px',
          "font-weight": "bold",
          style: _normalizeStyle(`transform:rotate(90deg) translate(0px, -${_ctx.size-4}px)`)
        }, _toDisplayString(_ctx.label), 13, _hoisted_4))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}
}

})